import ApiService from '@/services/core/api.service'

const ValidationService = {
  async isMobileUnique (payload) {
    return ApiService.post('shared/validations/is-mobile-unique', payload)
  }
}

export default ValidationService
